import { ChoicePropertyValue } from "./ChoicePropertyValue";
import type { PropertyValueProps } from "./types";

export const ManyPropertyValue = (props: PropertyValueProps) => <ChoicePropertyValue {...props} multiple />;
